import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('channel')

import Utils from "@/helpers/utils.js";

export default {
  namespaced: true,
  state: {
    channels: [],
  },
  mutations: {
    setChannel: (state, data) => { state.channels = Utils.sortData(data) }
  },
  actions: {
    getChannels: async ({commit}) => {
      try {
        const response = await api.get('channel/list')
        // console.log("channels :", response.data)
        commit('setChannel', response.data)
      } catch (e) {
        console.error('[axios] getChannels :', e.message)
      }
    }
  }
}